import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
// import ConfirmPopUpMobilization from "./ConfirmPopUp/ConfirmPopUpMobilization";
import ProjectDropDown from "../../../../ReusableComponents/ProjectDropDown/ProjectDropDown";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { getProjectData } from "../../../../store/Api";
import MobilizationConfrimPopUp from "../MobilizationData/MobilizationConfirmPopUp";

export default function RemobilizationFormPopUp({
  PopUp,
  setPopUp,
  listData,
  project_id,
  setTrigger,
  trigger,
}) {
  console.log("..........listData.......", listData, project_id);

  const [projectChange, setProjectChange] = useState(false);

  const [yesPopup, setYesPopup] = useState(false);
  const [existingClient, setExistingClient] = useState();
  const Project = useSelector((state) => state.projectData);
  const [jobPositions, setJobPositions] = useState([]);

  const [formData, setFormData] = useState({
    mobilizationDate: " ",
    serviceCharge: " ",
    contractType: " ",
    clientName: " ",
    clientId: "",
    mobileAllowance: " ",
    actualProfession: " ",
    airTicketAllowance: " ",
    basic: " ",
    additionalOt: " ",
    food: " ",
    otherAllowance: " ",
    fixedOt: " ",
    dutyHours: " ",
    hra: " ",
    fixedOtHours: " ",
    travelAllowance: " ",
    Employeelocation: "",
  });

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [projectId, setProjectId] = useState();
  const [initialData, setInitialData] = useState();

  function getDaysBetweenDates(date1, date2) {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = secondDate - firstDate;

    // Convert milliseconds to days
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return differenceInDays;
  }
  const [amountChange, setAmountChange] = useState(false);
  const submitHandler = async (e) => {
    debugger
    if (!formData.remobilizationDate || formData.remobilizationDate.trim() === "") {
      dispatch(
        setAppError({
          msg: "Mobilization Date is required....",
        })
      );
      return;
    }

    let idleAge = getDaysBetweenDates(
      listData.demobilization_date,
      formData.remobilizationDate
    );

    const parsedServiceCharge = parseInt(formData.serviceCharge);
    const parsedBasic = parseInt(formData.basic);
    const parsedFood = parseInt(formData.food);
    const parsedFixedOt = parseInt(formData.fixedOt);
    const parsedHra = parseInt(formData.hra);
    const parsedTravelAllowance = parseInt(formData.travelAllowance);
    const parsedMobileAllowance = parseInt(formData.mobileAllowance);
    const parsedAirTicketAllowance = parseInt(formData.airTicketAllowance);
    const parsedAdditionalOt = parseInt(formData.additionalOt);
    const parsedOtherAllowance = parseInt(formData.otherAllowance);

    const parsedServiceCharge_old = parseInt(initialData.serviceCharge);
    const parsedBasic_old = parseInt(initialData.basic);
    const parsedFood_old = parseInt(initialData.food);
    const parsedFixedOt_old = parseInt(initialData.fixedOt);
    const parsedHra_old = parseInt(initialData.hra);
    const parsedTravelAllowance_old = parseInt(initialData.travelAllowance);
    const parsedMobileAllowance_old = parseInt(initialData.mobileAllowance);
    const parsedAirTicketAllowance_old = parseInt(
      initialData.airTicketAllowance
    );
    const parsedAdditionalOt_old = parseInt(initialData.additionalOt);
    const parsedOtherAllowance_old = parseInt(initialData.otherAllowance);

    if (
      parseInt(initialData.serviceCharge) !== parsedServiceCharge ||
      parseInt(initialData.basic) !== parsedBasic ||
      parseInt(initialData.food) !== parsedFood ||
      parseInt(initialData.fixedOt) !== parsedFixedOt ||
      parseInt(initialData.hra) !== parsedHra ||
      parseInt(initialData.travelAllowance) !== parsedTravelAllowance ||
      parseInt(initialData.mobileAllowance) !== parsedMobileAllowance ||
      parseInt(initialData.airTicketAllowance) !== parsedAirTicketAllowance ||
      parseInt(initialData.additionalOt) !== parsedAdditionalOt ||
      parseInt(initialData.otherAllowance) !== parsedOtherAllowance
    ) {
      setAmountChange(true);
    }

    const totalSalary =
      parsedOtherAllowance +
      parsedAdditionalOt +
      parsedAirTicketAllowance +
      parsedMobileAllowance +
      parsedTravelAllowance +
      parsedHra +
      parsedFixedOt +
      parsedFood +
      parsedBasic +
      parsedServiceCharge;

    const Totalsalary_old =
      parsedServiceCharge_old +
      parsedBasic_old +
      parsedFood_old +
      parsedFixedOt_old +
      parsedHra_old +
      parsedTravelAllowance_old +
      parsedMobileAllowance_old +
      parsedAirTicketAllowance_old +
      parsedAdditionalOt_old +
      parsedOtherAllowance_old;

    const type = {
      employee_id: listData.candidate_id,
      mobilization_date: formData.remobilizationDate,
      demobilizationdate : null,
      remobilization_date: formData.remobilizationDate,
      project_id: formData.newProject_id,
      service_charge: parsedServiceCharge,
      contract_type: formData.contractType,
      client: formData.clientName,
      client_id: formData.clientId,
      actual_profession: formData.actualProfession,
      basic: parsedBasic,
      food: parsedFood,
      fixed_ot: parsedFixedOt,
      hra: parsedHra,
      travel_allowance: parsedTravelAllowance,
      mobile_allowance: parsedMobileAllowance,
      air_ticket_allowance: parsedAirTicketAllowance,
      additional_ot: parsedAdditionalOt,
      other_allowance: parsedOtherAllowance,
      Totalsalary: totalSalary,
      // Totalsalary_old : Totalsalary_old,
      duty_hours: formData.dutyHours,
      fixed_ot_hours: formData.fixedOtHours,
      sector_id: formData.sector_id,
      sponsor_id: formData.sponsor_id,
      company_id: formData.company_id,
      existingClient: existingClient,
      projectChange:
        listData.project_unique_id !== formData.newProject_id ||
          amountChange === true
          ? true
          : Totalsalary_old !== totalSalary
            ? true
            : false,
      idleAging: idleAge,
      old_Project_Id: listData.project_unique_id,
      Employeelocation: formData.Employeelocation,
      amountChange:
        amountChange === true
          ? true
          : Totalsalary_old !== totalSalary
            ? true
            : false,
    };

    console.log("Type object:", initialData, type);

    setLoading(true);
    try {
      const response = await nodeinstance.put(
        `/mobilization/remobilizeaddCandidate`,
        type,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLoading(false);
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setPopUp(false);
        setYesPopup(false);
        setTrigger(!trigger);
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
      }
    } catch (err) {
      setLoading(false);
      setError(err);
      console.log("Error:", err);
    }
  };

  const laravelToken = localStorage.getItem("token");
  useEffect(() => {
    getDetailsAutoFill();
    dispatch(getProjectData(laravelToken));
    fetchJobPositions();
  }, []);

  const fetchJobPositions = async () => {
    try {
      const response = await nodeinstance.get('/mobilization/getAllJobPositions', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.status === 200) {
        setJobPositions(response.data.data || []);
      }
    } catch (error) {
      console.log("Error fetching job positions:", error);
    }
  };

  const token = localStorage.getItem("nodeToken");
  const getProjectsId = async (e) => {
    const id = e.target.value;
    console.log(id);
    // setProjectId(id);
    const reqObject = {
      id: id,
    };
    try {
      const response = await nodeinstance.post(
        `mobilization/getDetailsByProject`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setProjectChange(true);
        if (response.data) {
          var setData = response?.data?.data[0];
          console.log(setData, "........................................");
          setFormData({
            ...formData,
            projectId: setData.project_id,
            contractType: setData.quotation_type,
            clientName: setData.client,
            clientId: setData.client_id,
            sector_id: setData.sector_id,
            sponsor_id: setData.sponsor_id,
            company_id: setData.company_id,
            newProject_id: setData.projectId,
            actualProfession: setData.actual_profession_id ? setData.actual_profession_id.toString() : "",
          });
        }
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.response?.message,
        })
      );
      setLoading(false);
      console.log("error", err);
    }
  };

  const getDetailsAutoFill = async () => {
    try {
      const response = await nodeinstance.get(
        `mobilization/getEmpData/${listData.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        var setData = response.data.data[0];
        console.log("my data....", setData);
debugger
        setFormData({
          ...formData,
          serviceCharge: setData.service_charge,
          contractType: setData.quotation_type,
          clientName: setData.client,
          clientId: setData.client_id_invoice,
          mobileAllowance: setData.mobile_allowance,
          actualProfession: setData.job_position_id ? setData.job_position_id.toString() : "",
          airTicketAllowance: setData.air_ticket_allowance,
          basic: setData.basic,
          additionalOt: setData.additional_ot,
          food: setData.food,
          otherAllowance: setData.other_allowance,
          fixedOt: setData.fixed_ot,
          dutyHours: setData.duty_hours,
          hra: setData.hra,
          fixedOtHours: setData.fixed_ot_hours,
          travelAllowance: setData.travel_allowance,
          projectId: setData.project_id,
          newProject_id: setData.projectId,
          Employeelocation: listData.Employeelocation,
        });
        setInitialData({
          serviceCharge: setData.service_charge,
          mobileAllowance: setData.mobile_allowance,
          actualProfession: setData.actual_profession,
          airTicketAllowance: setData.air_ticket_allowance,
          basic: setData.basic,
          additionalOt: setData.additional_ot,
          food: setData.food,
          otherAllowance: setData.other_allowance,
          fixedOt: setData.fixed_ot,
          dutyHours: setData.duty_hours,
          hra: setData.hra,
          fixedOtHours: setData.fixed_ot_hours,
          travelAllowance: setData.travel_allowance,
        });
        setProjectId(setData.project_id);
        setExistingClient(setData.client_id_invoice);
        console.log("id", projectId);
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
        setLoading(false);
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };
  console.log(formData);

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${PopUp ? "flex" : "hidden"
          }`}
      >
        <div className="max-w-xl w-full max-h-[40rem] min-h-[15rem] overflow-y-scroll overflow-x-hidden rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div
className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800"
            style={{ margin: 2 }}
          >
            <div className="w-full max-w-7xl mx-auto">
              {/* Form Header */}
              <div className="mb-6">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white">Employee Re-Mobilization Details</h2>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Fill in all required information below</p>
              </div>

              {/* Form Grid - Professional 2 Column Layout */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">

                {/* RE-Mobilization Date */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    RE-Mobilization Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="Date"
                    min={
                      listData.demobilization_date
                        ? new Date(listData.demobilization_date).toISOString().split("T")[0]
                        : ""
                    }
                    max={new Date().toISOString().split("T")[0]}
                    value={formData.remobilizationDate}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        remobilizationDate: e.target.value,
                      })
                    }
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>

                {/* Service Charge */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Service Charge <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.serviceCharge}
                    placeholder="Enter service charge"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        serviceCharge: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Contract Type */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Contract Type
                  </label>
                  <input
                    value={formData.contractType}
                    placeholder="Auto-populated"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-400 text-sm cursor-not-allowed"
                    disabled
                  />
                </div>

                {/* Project Name - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Project Name <span className="text-red-500">*</span>
                  </label>
                  <select
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    onChange={getProjectsId}
                    value={formData.projectId}
                  >
                    <option value="">Select Project</option>
                    {Project?.data?.map((data, index) => (
                      <option key={index} value={data.project_id}>{data.name}</option>
                    ))}
                  </select>
                </div>

                {/* Client Name - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Client Name
                  </label>
                  <input
                    value={formData.clientName}
                    placeholder="Auto-populated"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-400 text-sm cursor-not-allowed"
                    disabled
                  />
                </div>

                {/* Actual Profession - Full Width */}
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Actual Profession <span className="text-red-500">*</span>
                  </label>
                  <select
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    value={formData.actualProfession}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        actualProfession: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Profession</option>
                    {jobPositions.map((position, index) => (
                      <option key={index} value={position.id.toString()}>
                        {position.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Basic Salary */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Basic Salary <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.basic}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        basic: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Food Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Food Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.food}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        food: e.target.value,
                      })
                    }
                  />
                </div>

                {/* HRA */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    HRA <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.hra}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hra: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Fixed OT */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Fixed OT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.fixedOt}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        fixedOt: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Mobile Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Mobile Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.mobileAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mobileAllowance: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Travel Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Travel Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.travelAllowance}
                    placeholder="Based on contract"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        travelAllowance: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Air Ticket Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Air Ticket Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.airTicketAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        airTicketAllowance: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Additional OT */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Additional OT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.additionalOt}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        additionalOt: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Other Allowance */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Other Allowance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.otherAllowance}
                    placeholder="Enter amount"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        otherAllowance: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Duty Hours */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Duty Hours <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.dutyHours}
                    placeholder="Enter hours"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        dutyHours: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Fixed OT Hours */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Fixed OT Hours <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.fixedOtHours}
                    placeholder="Enter hours"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        fixedOtHours: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Employee Location */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-2">
                    Employee Location <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.Employeelocation}
                    placeholder="Enter location"
                    className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-sm transition-all duration-200"
                    required
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        Employeelocation: e.target.value,
                      })
                    }
                  />
                </div>

              </div>

              {/* Action Buttons Section */}
              <div className="mt-8 flex justify-center gap-4">
                {/* Cancel Button */}
                <button
                  type="button"
                  className="inline-flex items-center px-6 py-2.5 bg-btn-dark text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-dark-hover focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98]"
                  onClick={() => window.history.back()}
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Cancel
                </button>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="inline-flex items-center px-6 py-2.5 bg-btn-red text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-red-hover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setYesPopup(true)}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <CgSpinner className="w-4 h-4 mr-2 animate-spin" />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Submit Re-Mobilization
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {yesPopup ? (
        <MobilizationConfrimPopUp
          PopUp={yesPopup}
          setYesPopup={setYesPopup}
          title={"ARE YOU SURE YOU WANT TO PROCEED WITH THESE CHANGES"}
          callBack={submitHandler}
        />
      ) : (
        ""
      )}
    </>
  );
}
